import placeholderIcon from "assets/img/icons/special-offers.svg";
import placeholderIcon2 from "assets/img/icons/identity-Inspirations.svg";
import { useLocation } from "react-router-dom";
import { useCallback, useLayoutEffect, useState } from "react";
import { getUrlByPathname } from "consts/APIUrls";
import PlaceholderBlock from "components/placeholder-blocks/PlaceholderBlock";
import SpecialOffers from "components/special-offers/SpecialOffers";
import { createAPI } from "services/api/api";
import useProfile from "hooks/useProfile";
import useActiveItem from "hooks/useActiveItem";
import DashboardCraftBlocks from "components/DashboardCraftBlocks";
import GradientBlock from "components/GradientBlock";
import MainContentLeft from "components/main-components/MainContentLeft";

const Dashboard = () => {
  const api = createAPI();
  const { token } = useProfile();
  const { isActiveItem } = useActiveItem();
  const { pathname } = useLocation();
  const [items, setItems] = useState({
    packs: [],
    predictions: [],
    identities: [],
  });

  const filterPacks = (packs) => packs.map((item) => item.series).flat();

  const fetchMultipleData = useCallback(async () => {
    if (token) {
      api.get(getUrlByPathname(pathname).packs)
      .then((response) => {
        setItems((prevState) => ({
          ...prevState,
          packs: response.data.data !== null ? filterPacks(response.data.data ) : []
        }));
      })

      api
        .get(`${getUrlByPathname(pathname).predictions}pagination?limit=5&offset=0`
        )
        .then((response) => {
          setItems((prevState) => ({
            ...prevState,
            predictions: response.data.data,
          }));
        })
        .catch((error) => {
          console.log("Dashboard get predictions error:", error);
          setItems((prevState) => ({
            ...prevState,
            predictions: [],
          }));
        });

      api
        .get(
          `${getUrlByPathname(pathname).identities}pagination?limit=5&offset=0`
        )
        .then((response) => {
          setItems((prevState) => ({
            ...prevState,
            identities: response.data.data,
          }));
        })
        .catch((error) => {
          console.log("Dashboard get predictions error:", error);
          setItems((prevState) => ({
            ...prevState,
            identities: [],
          }));
        });
    }
  }, [token]);

  useLayoutEffect(() => {
    fetchMultipleData();
  }, [fetchMultipleData]);

  return (
    <>
      <GradientBlock>
        <h1 className='gradient-block__title'>Dashboard</h1>
      </GradientBlock>
      <main className="main-content main-content--dashboard">
        <MainContentLeft
          getOpenedClass={() => isActiveItem ? "opened" : ''}
        />
        <div className="main-content__right">
          {!items || !items.packs.length ? (
            <PlaceholderBlock
              img={placeholderIcon}
              title="Special Offers"
              info="More Packs Coming Soon"
            />
          ) : (
            <SpecialOffers list={items.packs} />
          )}
          <DashboardCraftBlocks items={items} />
          <PlaceholderBlock
            img={placeholderIcon2}
            title="Identity Inspirations"
            info="Coming soon..."
          />
        </div>
      </main>
    </>
  );
};

export default Dashboard;
